




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import Create, { typeCreate } from './Service/Create';
import roleForm from './form.json';

@Component
export default class roleCreate extends Vue {
  private roleForm: Object = roleForm;

  private form: typeCreate.request = {
    p5_role_status: '3',
    p5_role_name: '',
    p5_role_memo: '',
  };

  private keepCreate: boolean = false; // 判定: 繼續新增

  /** 送出表單 */
  public submitForm(formName: string) {
    const myForm: any = this.$refs[formName];
    myForm.validate((valid: boolean): void => {
      if (valid) {
        const getter = new Create(this.form);
        getter.post().then(() => {
          if (!this.keepCreate) {
            this.$emit('close');
          }
          this.resetForm(formName);
          this.$emit('update');
          this.keepCreate = false;
        });
      } else {
        const msg: any = this.$t('Util.validateError');
        this.$message.error(msg);
      }
    });
  }

  private resetForm(formName: string) {
    const myForm: any = this.$refs[formName];
    myForm.resetFields();
  }
}
